module.exports = __webpack_public_path__ + "static/media/cross.22048018.png";